import AuthenticatedResource from 'resources/AuthenticatedResource';

export default class VersionHistoryResource extends AuthenticatedResource {
  static urlRoot = '/organization/:organization/:type/:id/versions?history=:history';

  record_id   = undefined;
  record_type = undefined;
  created_at  = undefined;
  created_by  = undefined;
  updated_at  = undefined;
  updated_by  = undefined;
  history     = [];

  pk() {
    return `${this.record_type}/${this.record_id}`;
  }
}
